import ButtonActionComponent from "../../../../components/Button/ButtonActionComponent";
import { VaccsInput } from "./VaccsInput";
import { VaccsTableData } from "./GetVaccs";
import { TextVaccs1 } from "./TextVaccs1";


export default function VaccsActions() {

return(
<>      

<ButtonActionComponent

ListTitle={"Chronological Vaccination"}
ListComponent={<VaccsTableData />}
AddTitle={"Add new vaccination"}
AddComponent={<VaccsInput />}
InfoTitle={"Immunisation"}
InfoComponent={ <TextVaccs1 />}

/>

</>
)}